(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Vaccination', Vaccination);

    Vaccination.$inject = ['$resource', 'DateUtils'];

    function Vaccination ($resource, DateUtils) {
        var resourceUrl =  'api/vaccinations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.completionDate = DateUtils.convertLocalDateFromServer(data.completionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.completionDate = DateUtils.convertLocalDateToServer(copy.completionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.completionDate = DateUtils.convertLocalDateToServer(copy.completionDate);
                    return angular.toJson(copy);
                }
            },
            'getAllByPatientId': { 'url': 'api/vaccinations/patient/:id', method: 'GET', isArray: true},
        });
    }
})();
